import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import { convertDate, currentDate } from "@_common/date-helpers";
import {
  QueryRequestHelper,
  QueryRequestHelperShowFalse,
} from "@_common/query-request-helper";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  getChildEntityGroups,
  getEntityGroups,
  getUserEntityGroups,
  getUserEntityGroupsItems,
} from "@services/entity-mapping.service";
import SearchHeader from "@components/common/SearchHeader";
import DashboardFilterForm from "@components/common/DashboardFilterForm";
import {
  exportSelfCompliance,
  getDashboardSelfCompliance,
  getDashboardSelfComplianceUserEntity,
  getDashboardSelfComplianceUserEntityData,
  getDashboardSelfComplianceUserEntityDataWithoutGraph,
  refreshComplaince,
} from "@services/dashboard.service";
import { NewDate } from "@_common/date-helpers";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
// import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Loader from "@components/common/Loader";
import { formatString, formatText } from "@_common/format-text";
import DashboardUserFilterForm from "@components/common/DashboardFilterForm/user-filter-form";
import SelfComplianceTable from "./Table";
import Notfound from "@components/Not-Found";
import _ from "lodash";
import GraphLoader from "@components/common/GraphLoader";
import GraphNotfound from "@components/common/Graph-Not-Found";
import { tableStatusColors } from "@_common/colors";
import DownloadOfflineSvgComponent from "../../../assets/svg-components/download-offline";
import RefreshSvgComponent from "../../../assets/svg-components/refresh";
import ReactTooltip from "react-tooltip";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";

import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import DashboardSelfComplianceNotfound from "@components/Page-Not-Found/dashboard-self-compliance";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { countKeysWithValues } from "@_common/text-helpers";
import { ResponsivePie } from "@stu-dev/nivo-pie";
import html2canvas from "html2canvas";
import PaginationPage from "@components/pagination/pagination";
import FooterWrapper from "@components/common/FooterWrapper";
import ExpandableComplianceTable from "./expandableTable";
import { log } from "console";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
  // ChartDataLabels
);

type DonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

type NumberDonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

export default function DashboardSelfCompliance(props: any) {
  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                                UseState Section                            */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = useState(true);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [data, setData] = useState({});
  const [activityLabels, setActivityLabels] = useState([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };
  const [isAll, setIsAll] = React.useState(false);
  const location = useLocation();
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getSpecificGroupChart(1, page_no);
      getHeaderList(paramsObj, 0);

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getSpecificGroupChart(getValue(params, `level`, "1"), page_no);
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      } else {
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
        setLimitTable(parseInt(params.limit));
      }
      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
      if (Object.keys(paramObj).length > 0) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                                  API Section                               */
  /* -------------------------------------------------------------------------- */
  // Define colors for each key
  const colorsNew: { [key: string]: string } = {
    assigned: "#D0D3D4",
    posing: "#fd9933",
    complied: "#05a357",
    non_complied: "#EC7063",
    delayed: "#D4AC0D",
    delayed_reported: "#85C1E9",
    re_opened: "#FADBD8",
    event_not_occurred: "#BF94BC",
    event_not_occured: "#BF94BC",
    awaiting_approval: "#4B6C81",
    reported_non_complied: "#c25071",
  };

  const colorsChartNew = [
    "#D0D3D4",
    "#fd9933",
    "#05a357",
    "#EC7063",
    "#D4AC0D",
    "#85C1E9",
    "#FADBD8",
    "#BF94BC",
    "#4B6C81",
    "#c25071",
  ];

  const [donutData, setDonutData] = useState<DonutDataItem[]>([]);
  const [numberDonutData, setNumberDonutData] = useState<NumberDonutDataItem[]>(
    []
  );

  function snakeToCamelWithSpaces(str: string): string {
    if (str === "event_not_occured" || str === "event_not_occurred") {
      return "Event Not Occurred";
    }
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const getData = async () => {
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
        // user_id:getValue(user,`id`,'')
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfComplianceUserEntity(queryRequest);
      if (resp) {
        // Self Compliance Percentage Graph
        const dataNew = getValue(resp, `data.fixed`, {});
        const total: number = Object.values(dataNew).reduce(
          (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
          0
        );
        const transformedData: DonutDataItem[] = Object.entries(dataNew).map(
          ([id, value], index) => {
            return {
              id: snakeToCamelWithSpaces(id),
              label: snakeToCamelWithSpaces(id),
              value:
                typeof value === "number"
                  ? parseFloat(((value / total) * 100).toFixed(2))
                  : 0,
              color: colorsNew[id],
            };
          }
        );

        const formattedTransformedData: DonutDataItem[] = transformedData.map(
          (item) => ({
            ...item,
            value: parseFloat(item.value.toFixed(2)),
            displayValue: item.value.toFixed(2) + "%",
          })
        );
        setDonutData(formattedTransformedData);

        // Self Compliance Number Graph
        const dataNewNumber = getValue(resp, `data.fixed`, {});
        const totalNumber: number = Object.values(dataNewNumber).reduce(
          (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
          0
        );
        const transformedDataNumber: NumberDonutDataItem[] = Object.entries(
          dataNewNumber
        ).map(([id, value], index) => ({
          id: snakeToCamelWithSpaces(id),
          label: snakeToCamelWithSpaces(id),
          value: typeof value === "number" ? value : 0,
          color: colorsNew[id],
        }));

        const formattedTransformedDataNumber: NumberDonutDataItem[] =
          transformedDataNumber.map((item) => ({
            ...item,
            value: parseFloat(item.value.toFixed(2)),
            displayValue: item.value.toFixed(2),
          }));
        setNumberDonutData(formattedTransformedDataNumber);

        setData(getValue(resp, `data.percentage`, {}));
        let labels: any = Object.keys(getValue(resp, `data.percentage`, {}));
        setActivityLabels(labels);
        let formattedLabels: any =
          getValue(labels, `length`, 0) > 0
            ? labels.map((item: any) => formatText(item))
            : [];
        let data: any = labels.map((item: any) =>
          parseFloat(getValue(resp, `data.percentage`, {})[item])
        );
        setValue(pieChartData, `labels`, formattedLabels);
        setValue(pieChartData, `datasets[${0}].data`, data);

        let data1: any = labels.map((item: any) =>
          parseFloat(getValue(resp, `data.fixed`, {})[item])
        );
        setValue(pieChartData1, `labels`, formattedLabels);
        setValue(pieChartData1, `datasets[${0}].data`, data1);

        setValue(barChartData, `labels`, formattedLabels);
        setValue(barChartData, `datasets[${0}].data`, data);
        setBarChartData({
          ...barChartData,
        });
        setPieChartData({
          ...pieChartData,
        });
        setPieChartData1({
          ...pieChartData1,
        });

        // setTimeout(() => {
        setIsLoading(false);
        // }, 1000);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataParamsObj = async (paramsObj: object) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfComplianceUserEntity(queryRequest);
    console.log(resp,"1")
      // let resp = await getDashboardSelfCompliance(queryRequest);
      if (resp) {
        setData(getValue(resp, `data`, {}));
        let labels: any = Object.keys(getValue(resp, `data`, {}));
        setActivityLabels(labels);
        let formattedLabels: any =
          getValue(labels, `length`, 0) > 0
            ? labels.map((item: any) => formatString(item))
            : [];
        let data: any = labels.map(
          (item: any) => getValue(resp, `data`, {})[item]
        );
        setValue(pieChartData, `labels`, formattedLabels);
        setValue(pieChartData, `datasets[${0}].data`, data);

        // setValue(barChartData, `labels`, formattedLabels);
        // setValue(barChartData, `datasets[${0}].data`, data);
        // setBarChartData({
        //   ...barChartData,
        // });
        setPieChartData({
          ...pieChartData,
        });
        // setTimeout(() => {
        setIsLoading(false);
        // }, 1000);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerGroupList, setHeaderGroupList] = useState<any>([]);

  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
      // user_id:getValue(user,`id`,'')
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      // let resp = await getUserEntityGroups(queryRequest)
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        let headers = [{ group_name: "Overall" }];
        let headerGroups = getValue(resp, `data.entityGroups`, []);
        setHeaderGroupList(headers.concat(headerGroups));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];

        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );

          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any, i: number) =>
                ite.group_level - 1 === parseInt(item.split("_")[2])
            );
            // if (_index === index)
            return getEntityList(
              parseInt(item.split("_")[2]) + 1,
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              ""
            );
          });
        } else {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number,
    group_level: any,
    entity_id: any
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            group_level,
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            entity_id,
            ""
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    group_level: any,
    group_id: string,
    entity_id: any,
    search_text: string
  ) => {
    let payload = {
      limit: 10,
      search_text: search_text,
      level: group_level,
      entity_parent: entity_id,
    };

    let queryRequest = QueryRequestHelper(payload);
    setChildEntityLoading(true);
    try {
      // let resp = await getChildEntityGroups(queryRequest);
      let resp = await getUserEntityGroupsItems(queryRequest);
      if (resp) {
        levelObj[group_id] = getValue(resp, `data.entityMapping`, []).map(
          (item: any) => ({
            ...item,
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          })
        );
        setLevelObj({ ...levelObj });
        setChildEntityLoading(false);
      } else {
        setChildEntityLoading(false);
      }
    } catch (error) {
      setChildEntityLoading(false);
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    group_id: string,
    group_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(group_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(group_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(group_level, group_id, entityID, "");
      let length = Object.keys(paramsObj).length;
      for (let i = group_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(group_level, group_id, entityID, val);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState<any>(null);
  const [to_date, setLastDay] = React.useState<any>(null);

  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        from_date: convertDate(first),
        to_date: convertDate(last),
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };
  const handleSubmitSmartFilter = () => {
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      // page_no: getValue(params, `page_no`, ""),
      // search_text: getValue(params, `search_text`, ""),
      // limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setParamsObj({});
    setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getDataParamsObj({});
  };
  /* -------------------------------------------------------------------------- */
  /*                              Chart Section                                 */
  /* -------------------------------------------------------------------------- */
  /* ---------------------------------- Pie Chart ----------------------------- */

  const [pieChartData, setPieChartData] = useState<any>({
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          // "rgb(242,165,152)",
          // "rgb(255,232,157)",
          // "rgb(236,107,109)",
          // "rgb(122,231,125)",
          // "rgb(195,233,151)",
          // "#ffcd56",
          // "#4bc0c0"
          "#D0D3D4",
          "#fd9933",
          "#05a357",
          "#EC7063",
          "#D4AC0D",
          "#85C1E9",
          "#FADBD8",
          "#BF94BC",
          "#4B6C81",
        ],
        borderWidth: 1,
      },
    ],
  });

  const [pieChartData1, setPieChartData1] = useState<any>({
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          // "rgb(242,165,152)",
          // "rgb(255,232,157)",
          // "rgb(236,107,109)",
          // "rgb(122,231,125)",
          // "rgb(195,233,151)",
          // "#ffcd56",
          // "#4bc0c0"
          "#D0D3D4",
          "#fd9933",
          "#05a357",
          "#EC7063",
          "#D4AC0D",
          "#85C1E9",
          "#FADBD8",
          "#BF94BC",
          "#4B6C81",
        ],
        borderWidth: 1,
      },
    ],
  });

  const handleClickPieChart = (index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let selectedEnum =
        getValue(activityLabels, `length`, 0) > 0
          ? activityLabels.filter((_item: string, ind: number) => index === ind)
          : [];
      let payload: any = {
        ...params,
        from_date: convertDate(first),
        to_date: convertDate(last),
        request_value:
          getValue(selectedEnum, `[${0}]`, "") === "delay_reported"
            ? "DELAYED_REPORTED"
            : getValue(selectedEnum, `[${0}]`, "").toUpperCase(),
        request_from: "MASTER",
        is_user_entity: true,
      };
      let queryRequest = QueryRequestHelper(payload);
      if (getValue(selectedEnum, `length`, 0) > 0) {
        navigate(`/repository/mapped-checkpoint/master?${queryRequest}`);
      }
    } else {
      toast.error("From and To Date Required");
    }
  };

  /* ---------------------------------- Bar Chart ----------------------------- */
  const [barChartData, setBarChartData] = useState({
    labels: ["Default"],
    datasets: [
      {
        label: "Compliance",
        data: [98, 120, 138, 138],
        // backgroundColor: ["#2E86C1", "#3498DB", "#5DADE2", "#85C1E9"],
        backgroundColor: [
          "#F4F6F6",
          "#fd9933",
          "#05a357",
          "#d7252e",
          "#05a357",
          "rgb(195,233,151)",
          "#F1948A",
          "#4B6C81",
        ],
      },

      // {
      // 	label: "Dataset 2",
      // 	data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // 	backgroundColor: "rgba(53, 162, 235, 0.5)",
      // },
    ],
  });
  const optionsPercentage: any = {
    responsive: true,
    maintainAspectRatio: false, //width
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          return val ? `${val}%` : ""; // Adding percentage symbol if value is not null
        },
      },
      legend: {
        position: "right" as const,
        color: "white",
        // labels: {
        // 	color: "black",
        // 	font: {
        // 		size: 18,
        // 	},
        // },
      },
      title: {
        display: true,
        // text: "Overall Compliance",
      },
    },
    // scales: {
    // 	y: {
    // 		ticks: {
    // 			color: "green",
    // 			font: {
    // 				size: 18,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},
    // 	},
    // 	x: {
    // 		ticks: {
    // 			color: "purple",
    // 			font: {
    // 				size: 14,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},>
    // 	},
    // },
  };
  const options: any = {
    responsive: true,
    maintainAspectRatio: false, //width
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          return val ? val : null;
        },
      },
      legend: {
        position: "right" as const,
        color: "white",
        // labels: {
        // 	color: "black",
        // 	font: {
        // 		size: 18,
        // 	},
        // },
      },
      title: {
        display: true,
        // text: "Overall Compliance",
      },
    },
    // scales: {
    // 	y: {
    // 		ticks: {
    // 			color: "green",
    // 			font: {
    // 				size: 18,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},
    // 	},
    // 	x: {
    // 		ticks: {
    // 			color: "purple",
    // 			font: {
    // 				size: 14,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},>
    // 	},
    // },
  };
  const groupChartOptions: any = {
    responsive: true,
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 14,
            },
          },
        },
        // formatter: (val: any) => {
        //   return val+`%`;
        // },
        formatter: (val: any) => (val ? `${val}%` : ""),
      },
      legend: {
        position: "right" as const,
        color: "white",
        // labels: {
        // 	color: "black",
        // 	font: {
        // 		size: 18,
        // 	},
        // },
      },
      title: {
        display: true,
        // text: "Overall Compliance",
      },
    },
    // scales: {
    // 	y: {
    // 		ticks: {
    // 			color: "green",
    // 			font: {
    // 				size: 18,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},
    // 	},
    // 	x: {
    // 		ticks: {
    // 			color: "purple",
    // 			font: {
    // 				size: 14,
    // 			},
    // 			stepSize: 1,
    // 			beginAtZero: true,
    // 		},>
    // 	},
    // },
  };
  /* ---------------------------------- Pie Group Chart ----------------------------- */
  const initialData = {
    labels: ["Default"],
    datasets: [
      {
        label: "Default",
        data: [],
        backgroundColor: [
          "rgb(242,165,152)",
          "rgb(255,232,157)",
          "rgb(236,107,109)",
          "rgb(122,231,125)",
          "rgb(195,233,151)",
          "#ffcd56",
          "#4bc0c0",
          "#4B6C81",
        ],
        stack: "",
        borderWidth: 1,
      },
    ],
  };
  const [groupChart, setGroupChart] = useState([]);
  const [groupChartLoading, setGroupChartLoading] = useState(false);
  const [groupPieChart, setGroupPieChart] = useState(initialData);
  const [groupActivityLabels, setGroupActivityLabels] = useState([]);
  const handleClickGroupPieChart = (level: any, groupName?: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const currentParams = Object.fromEntries(urlSearchParams.entries());

    // Remove existing level-specific parameters (level1, level2, etc.)
    // and potentially an old group_name if you decide to always overwrite it
    Object.keys(currentParams).forEach((key) => {
      if (key.startsWith("level") && key !== "level") {
        delete currentParams[key];
      }
      if (key === "group_name") {
        // Remove old group_name if present
        delete currentParams[key];
      }
    });

    let newParams: any = {
      ...currentParams, // Keep existing params like date range
    };

    if (level) {
      newParams.level = level;
      if (groupName) {
        // Add the new group_name if provided
        newParams.group_name = groupName;
      }
    } else {
      // If level is cleared (e.g., clicking "Overall" or a similar reset)
      delete newParams.level;
      delete newParams.group_name; // Also remove group_name
    }

    // Clean up undefined/null keys from the newParams
    Object.keys(newParams).forEach((key) => {
      if (
        newParams[key] === undefined ||
        newParams[key] === null ||
        newParams[key] === ""
      ) {
        delete newParams[key];
      }
    });

    const queryRequest = QueryRequestHelper(newParams);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const handleOnClickGroupPieChart = (index: any) => {
    let selectedChart: any = groupChart.filter(
      (_item: object, i: number) => index === i
    );
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let first: any = from_date ? NewDate(from_date) : null;
    let last: any = to_date ? NewDate(to_date) : null;
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        from_date: convertDate(first),
        to_date: convertDate(last),
        request_from: "MASTER",
        level_key: `${getValue(params, `level`, "")}`,
        level_value: getValue(selectedChart, `[${0}].group_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/repository/mapped-checkpoint/master?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };
  const getSpecificGroupChart = async (
    level: any,
    page_no: any,
    group_name?: string,
    page_size = 15,
  ) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        page_no: page_no,
        page_size,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
        level: level ? level : 1,
        group_name: params.group_name ? params.group_name : "",
        isAll: params.isAll,
        // is_graph: true,
        // is_list: false,
        // user_id:getValue(user,`id`,'')
      };

      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }

      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });

      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });

      let payload1: any = {
        page_no: page_no,
        page_size,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
        level: level ? level : 1,
        group_name: params.group_name ? params.group_name : "",
        isAll: params.isAll,
      };
      Object.keys(payload1).forEach((key) => {
        if (!payload1[key] || payload1[key] === undefined) {
          delete payload1[key];
        }
      });

      let queryRequest1 = QueryRequestHelperShowFalse({
        ...payload1,
        ...levelObj,
      });
      setGroupChartLoading(true);
      let resp;
      let resp1;
      // if (level == 5) {
      if (getValue(params, `group_name`, "") === "Function") {
        resp = await getDashboardSelfComplianceUserEntityData(
          queryRequest,
          false,
          true
        );
            console.log(resp,"2")

        resp1 = await getDashboardSelfComplianceUserEntityData(
          queryRequest1,
          false,
          true
        );
            console.log(resp,"3")

      } else {
        resp = await getDashboardSelfComplianceUserEntityDataWithoutGraph(
          queryRequest,
          false
        );
            console.log(resp,"4")

        resp1 = await getDashboardSelfComplianceUserEntityDataWithoutGraph(
          queryRequest1,
          true
        );
            console.log(resp,"5")

      }

      if (resp1) {
        // if (level == 5) {
        if (getValue(params, `group_name`, "") === "Function") {
          setListTable(getValue(resp, `data.by_entity`, {}));
          let arr: any = [];
          const entityData = getValue(resp1, `data.by_entity`, {});

          // Convert the new data structure to match the expected format
          Object.entries(entityData).forEach(([department, stats]) => {
            arr.push({
              group_name: department,
              group_display_name: department,
              group_id: department,
              data: stats,
            });
          });

          setGroupChart(arr.length > 0 ? arr : []);
          setGroupChartLoading(false);
          setTotalCountTable(getValue(resp, `data.pagination.total`, 0));
        } else {
          setListTable(getValue(resp, `data.by_entity`, {}));
          let arr: any = [];
          let length: any = Object.entries(
            getValue(resp1, `data.by_entity`, {})
          ).length;
          for (let i = 0; i < length; i++) {
            let filtered = Object.entries(
              getValue(resp1, `data.by_entity`, {})
            )[i][0].split("::");
            arr.push({
              group_name: filtered[1],
              group_display_name: filtered[1] + ":" + filtered[3],
              group_id: filtered[0],
              data: Object.entries(getValue(resp1, `data.by_entity`, {}))[i][1],
            });
          }
          setGroupChart(getValue(arr, `length`, 0) > 0 ? arr : []);
          setGroupChartLoading(false);
          setTotalCountTable(getValue(resp, `data.pagination.total`, 0));
        }
        // setListTable(getValue(resp, `data.by_entity`, {}));
        // let arr: any = [];
        // let length: any = Object.entries(getValue(resp1, `data.by_entity`, {}))
        //   .length;
        // for (let i = 0; i < length; i++) {
        //   let filtered = Object.entries(getValue(resp1, `data.by_entity`, {}))[
        //     i
        //   ][0].split("::");
        //   arr.push({
        //     group_name: filtered[1],
        //     group_display_name: filtered[1] + ":" + filtered[3],
        //     group_id: filtered[0],
        //     data: Object.entries(getValue(resp1, `data.by_entity`, {}))[i][1],
        //   });
        // }
        // setGroupChart(getValue(arr, `length`, 0) > 0 ? arr : []);
        // setGroupChartLoading(false);
        // setTotalCountTable(getValue(resp, `data.pagination.total`, 0));
      } else {
        setGroupChartLoading(false);
      }
      if (resp) {
        // if (level == 5) {
        if (getValue(params, `group_name`, "") === "Function") {
          // alert(level);
          const inputJson = getValue(resp, `data.by_entity`, {});
          // No need for combining states since data is already organized by department

          let labels: any = Object.keys(inputJson);
          setGroupActivityLabels(labels);
          let formattedLabels =
            labels.length > 0
              ? labels.map((item: any) => formatString(item))
              : [];

          const newData = _.cloneDeep(initialData);

          // Get all possible status types from the first department
          const firstDepartment = inputJson[labels[0]] || {};
          const statusTypes = Object.keys(firstDepartment).filter(
            (key) => key !== "total_count"
          );

          // Create datasets for each status type
          const datasets = statusTypes.map((statusType) => {
            const dataPoints = labels.map((department: any) => {
              const value = getValue(
                inputJson,
                `[${department}][${statusType}]`,
                0
              );
              const total = getValue(
                inputJson,
                `[${department}].total_count`,
                0
              );
              // Calculate percentage
              return total ? parseFloat(((value / total) * 100).toFixed(2)) : 0;
            });

            return {
              label: formatText(statusType),
              stack: "",
              data: dataPoints,
              backgroundColor: tableStatusColors(statusType.toUpperCase()),
            };
          });

          newData.datasets = datasets;
          newData.labels = formattedLabels;

          setValue(groupPieChart, `labels`, formattedLabels);
          setGroupPieChart(newData);
          setTotalCount(getValue(resp, `data.pagination.total`, 0));
        } else {
          const combinedStates: any = {};
          const inputJson = getValue(resp, `data.by_entity`, {});
          for (const key in inputJson) {
            const stateName = key.split("::")[1];
            if (combinedStates[stateName]) {
              // If the state already exists, add the properties
              for (const prop in inputJson[key]) {
                combinedStates[stateName][prop] += inputJson[key][prop];
              }
            } else {
              // If the state doesn't exist, create a new entry
              combinedStates[stateName] = { ...inputJson[key] };
            }
          }

          // Ensure that the sum of properties for each state is equal to 100
          for (const stateName in combinedStates) {
            const stateData = combinedStates[stateName];
            const total: any = Object.values(stateData).reduce(
              (acc: any, val) => acc + val,
              0
            );
            if (total !== 100) {
              // Adjust the values to make the total 100
              const factor = 100 / total;
              for (const prop in stateData) {
                stateData[prop] = parseFloat(
                  (stateData[prop] * factor).toFixed(2)
                );
              }
            }
          }
          let labels: any = Object.keys(combinedStates);
          setGroupActivityLabels(labels);
          let formattedLabels: any =
            getValue(labels, `length`, 0) > 0
              ? labels.map((item: any) => formatString(item))
              : [];
          const newData = _.cloneDeep(initialData);
          for (let i = 0; i < labels.length; i++) {
            const normalizedLabel =
              getValue(labels, `[${i}]`, "") &&
              labels[i].replace(/[\s.]+/g, "");
            const normalizedbject: any = {};
            let data: any = combinedStates;
            for (const key in data) {
              if (Object.hasOwnProperty.call(data, key)) {
                // Remove spaces and periods from the key
                const modifiedKey = key && key.replace(/[\s.]+/g, "");
                // Assign the value to the modified key in the new object
                normalizedbject[modifiedKey] = data[key];
              }
            }
            const keys = Object.keys(
              getValue(normalizedbject, `[${normalizedLabel}]`, {})
            );
            let modifiedLabels =
              getValue(labels, `length`, 0) > 0 &&
              labels.map((item: any) => item && item.replace(/[\s.]+/g, ""));
            let obj =
              getValue(keys, `length`, 0) > 0 &&
              keys.map((item) => {
                let arr: any = [];
                getValue(labels, `length`, 0) > 0 &&
                  modifiedLabels.map((lab: any, index: number) => {
                    return arr.push(
                      getValue(
                        normalizedbject,
                        `[${modifiedLabels[index]}][${item}]`,
                        0
                      )
                    );
                  });
                return {
                  label: formatText(item),
                  stack: "",
                  data: arr,
                  backgroundColor: tableStatusColors(item.toUpperCase()),
                };
              });

            newData.datasets = obj;
          }
          newData.labels = formattedLabels || [];
          setValue(groupPieChart, `labels`, formattedLabels);
          // setValue(groupPieChart, `datasets[${0}].data`, data);

          setGroupPieChart(newData);
          setTotalCount(getValue(resp, `data.pagination.total`, 0));
        }
      } else {
        setIsLoading(false);
        setGroupChartLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setGroupChartLoading(false);
    }
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  let selectedEntity =
    getValue(headerList, `length`, 0) > 0
      ? headerList.filter(
          (item: any, index: number) =>
            getValue(item, `group_level`, 0) == getValue(params, `level`, 0) ||
            (index === 0 && !getValue(params, `level`, 0))
        )
      : [];

  const handleNavigate = (id: string, value: string) => {
    const formattedHeader =
      value === "DELAY_REPORTED" ? "DELAYED_REPORTED" : value;

    if (id !== "-") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let first: any = from_date ? NewDate(from_date) : null;
      let last: any = to_date ? NewDate(to_date) : null;
      if (
        first &&
        last &&
        first !== "Invalid date" &&
        last !== "Invalid date"
      ) {
        let payload: any = {
          ...params,
          from_date: convertDate(first),
          to_date: convertDate(last),
          request_value: formattedHeader,
          request_from: "MASTER",
          level_key: `${getValue(params, `level`, "")}`,
          level_value: id,
        };
        let queryRequest = QueryRequestHelper(payload);
        navigate(`/repository/mapped-checkpoint/master?${queryRequest}`);
      } else {
        toast.error("Please select date");
      }
    }
  };

  const options1: any = {
    responsive: true,
    barPercentage: 0.3,
    plugins: {
      tooltip: {
        callbacks: {
          title: (xDatapoint: any) => {
            return `${getValue(xDatapoint, `[${0}].dataset.label`, "")}`;
          },
          label: (yDatapoint: any) => {
            return `${yDatapoint.raw}%`;
          },
        },
      },
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          return "";
        },
      },
      legend: {
        position: "right" as const,
        color: "white",
        labels: {
          boxWidth: 18, // Set this to your desired width
          boxHeight: 18, // Set this to your desired height
          font: {
            size: 10, // Set this to your desired font size
          },
          padding: 4,
        },
      },
      title: {
        display: true,
        text: "Overall Self Compliance (%)",
      },
    },
    // scales: {
    // yAxes: [{ stacked: true }],
    // xAxes: [
    // {
    // stacked: true,
    // },
    // ],
    // },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      report_type: "SELF_COMPLIANCE_TASK_ENTITY",
      report_name: `self_compliance_task_entity_report_${currentDate()}`,
      from_date: from_date,
      to_date: to_date,
      level: getValue(params, `level`, 0),
      is_list: "true",
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportSelfCompliance({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SELF_COMPLIANCE_TASK_ENTITY`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Chart Section                                */
  /* -------------------------------------------------------------------------- */
  const chartRef = useRef<any>(null);
  const chartRef1 = useRef<any>(null);
  const barChartRef = useRef<any>(null);

  const handleDownloadClick = () => {
    const chartCanvas = chartRef1.current.canvas;
    if (chartCanvas) {
      const image = chartCanvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream");

      const a = document.createElement("a");
      a.href = image;
      a.download = "overall.jpg";
      a.click();
    }
  };
  const handleDownloadBarClick = () => {
    const chartCanvas = barChartRef.current.canvas;

    if (chartCanvas) {
      const image = chartCanvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream");

      const a = document.createElement("a");
      a.href = image;
      a.download = `${getValue(selectedEntity, `[${0}].group_name`, "")}.jpg`;
      a.click();
    }
  };

  const handleRefresh = async () => {
    try {
      let resp = await refreshComplaince();
      if (resp) {
        getData();
      }
    } catch (error) {}
  };

  const handleDownloadPie = (containerId: any) => {
    const chartContainer = document.getElementById(containerId);
    if (chartContainer) {
      html2canvas(chartContainer).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/jpg");
        link.download = "piechart.jpg";
        link.click();
      });
    } else {
      console.error(`Chart container with ID "${containerId}" not found`);
    }
  };
  // Code for Tab Pane

  const [activeTab, setActiveTab] = useState<string>("1");

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const dataHelper = (array: any) => {
    if (getValue(array, `length`, 0) > 0) {
      const sum = array.reduce(
        (accumulator: any, currentValue: any) =>
          parseFloat(accumulator) + parseFloat(currentValue),
        0
      );
      return sum;
    } else {
      return 0;
    }
  };

  const formatLabelValue = (value: any) => {
    return value
      .split("_")
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  /* -------------------------------------------------------------------------- */
  /* Pagination section */
  /* -------------------------------------------------------------------------- */
  const [list, setList] = React.useState<[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(15);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: number) => {
    setPage_no(page_no);
    getSpecificGroupChart(params.level, page_no, params.group_name, limit);
  };
  const handleChangeLimit = (limit: string) => {
    const newLimit = Number(limit);
    setLimit(newLimit);
    setPage_no(1);
    getSpecificGroupChart(params.level, 1, params.group_name, newLimit);
  };

  // Pagination Table
  const [listTable, setListTable] = React.useState<[]>([]);
  const [totalCountTable, setTotalCountTable] = useState(0);
  const [limitTable, setLimitTable] = useState(15);
  const [page_no_table, setPage_no_table] = useState(1);

  const handleChangePaginationTable = (page_no_table: number) => {
    setPage_no_table(page_no_table);
    getSpecificGroupChart(
      params.level,
      page_no_table,
      params.group_name,
      limitTable,
    );
  };
  const handleChangeLimitTable = (limit: string) => {
    const newLimit = Number(limit);
    setLimitTable(newLimit);
    setPage_no_table(1);
    getSpecificGroupChart(params.level, 1, params.group_name, newLimit);
  };

  const handleIsAllToggle = () => {
    setIsAll((prev) => !prev);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("isAll", String(isAll));
    navigate(`${location.pathname}?${params.toString()}`);
  }, [isAll, location.pathname, location.search, navigate]);

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "dashboard_self_compliance_compliance"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Self Compliance</h4>
            <div className="d-flex">
              <div className="refresh-button-wrapper">
                <button onClick={() => handleRefresh()} className={`btn`}>
                  <RefreshSvgComponent size={24} color={"#5F6368"} />
                </button>
              </div>
              <div className="filter-form-wrappper__container d-flex ms-2">
                {/* Legal Due Date */}
                <DatePicker
                  selectsRange={true}
                  startDate={from_date}
                  endDate={to_date}
                  className="react-date-picker__inputGroup__input"
                  onChange={(update: any) => {
                    handleDate(update);
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Legal Due Date"
                />
                <button
                  className="dashboard-wrapper__apply-btn"
                  onClick={handleSubmitDate}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Self Compliance
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Compliance</h4>
              </div>
              {getValue(props, `permissions`, []).includes(
                "view_all_functions"
              ) && (
                <div className="d-flex align-items-center flex-nowrap mx-2 ms-4">
                  <h4
                    className="header_text__blue mb-0 me-2"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Consolidated View
                  </h4>
                  <div className="choicelist-wrapper custom-switch-wrapper">
                    <label className="switch mb-0">
                      <input
                        type="checkbox"
                        checked={isAll}
                        onChange={handleIsAllToggle}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                smartFilter={true}
                handleFilter={handleFilter}
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                licenseStyleCalendar={true}
              />
              <div className="refresh-button-wrapper sub-header-icons-holder ms-0">
                <button
                  onClick={() => handleRefresh()}
                  className={`icons-btn`}
                  data-tip
                  data-for="checkTest"
                >
                  <RefreshSvgComponent size={24} color={"#5F6368"} />
                  <ReactTooltip id="checkTest" effect="solid" place="bottom">
                    Refresh
                  </ReactTooltip>
                </button>
              </div>
            </div>
          </div>

          <div className="main-page-layout-wrapper main-page-layout-wrapper-dashboard pb-2">
            <div className="admin-wrapper position-relative">
              {
                <div className="admin-wrapper position-relative d-none">
                  <SearchHeader
                    smartFilter={!getValue(params, `level`, 0) ? true : false}
                    setFilterFormVisibility={() => {
                      setFilterVisibility(!isFilterVisible);
                    }}
                    add={"false"}
                    search={"false"}
                    isFilterVisible={isFilterVisible}
                    //download section
                    downloadSelfComplianceReport={
                      getValue(params, `level`, 0) ? true : false
                    }
                    handleDownloadSelfComplianceReport={
                      handleDownloadSelfComplianceReport
                    }
                    downloadLoading={downloadLoading}
                    filterIsOpen={filterIsOpen}
                    handleFilter={() => {
                      setFilterIsOpen(!filterIsOpen);
                    }}
                  />
                </div>
              }
              {/* {isFilterVisible && ( */}
              <>
                <DashboardUserFilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                  //-----> Entity Mapping Filter
                  headerList={headerList}
                  headerLoading={headerLoading}
                  levelObj={levelObj}
                  childEntityLoading={childEntityLoading}
                  handleClickEntity={handleClickEntity}
                  urlParams={paramsObj}
                  handleChangeEntity={handleChange}
                  filterIsOpen={filterIsOpen}
                  handleFilter={handleFilter}
                  moduleName={"Self Compliance"}
                  subModuleName={"Compliance"}
                />
              </>
              {/* )} */}
            </div>
            {
              <div className="entity_chart-container">
                <div className="entity_float">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="entity-header-container">
                      {getValue(headerGroupList, `length`, 0) > 0 ? (
                        headerGroupList.map((item: object, index: number) => {
                          return (
                            <div key={index}>
                              <div
                                className={`entity-header ${
                                  getValue(item, `group_level`, "") ==
                                  getValue(params, `level`, "")
                                    ? `active`
                                    : index === 0 &&
                                      !getValue(params, `level`, "")
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleClickGroupPieChart(
                                    getValue(item, `group_level`, ""),
                                    getValue(item, `group_name`, "")
                                  )
                                }
                              >
                                <p className="entity-header_text">
                                  {getValue(item, `group_name`, "")}
                                </p>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </div>
                    <div></div>
                  </div>
                  <hr />

                  <div>
                    {isLoading ? (
                      <GraphLoader />
                    ) : (
                      <div>
                        {getValue(params, `level`, "") ? (
                          getValue(
                            groupPieChart,
                            `datasets[${0}].data.length`,
                            0
                          ) === 0 ? (
                            <div style={{ height: "375px" }}>
                              <DashboardSelfComplianceNotfound />
                            </div>
                          ) : (
                            <>
                              <div className="vendor-graph-holder">
                                <div className="self-compliance-download-button-holder">
                                  <button
                                    onClick={handleDownloadBarClick}
                                    className="download_chart mx-1 hover-effective-icon-btn"
                                  >
                                    <DownloadNoCircleSvgComponent
                                      size={20}
                                      color={"#5F6368"}
                                    />
                                  </button>
                                </div>

                                <div style={{ height: "320px" }}>
                                  <Bar
                                    data={groupPieChart}
                                    options={{
                                      ...options1,
                                      responsive: true,
                                      maintainAspectRatio: false,
                                      // onClick: function (evt, element) {
                                      //   let ind = getValue(element, `[${0}].index`, null);
                                      //   if (element.length > 0) {
                                      //     handleOnClickGroupPieChart(ind);
                                      //   }
                                      // },
                                    }}
                                    ref={barChartRef}
                                  />
                                </div>
                                {totalCount > 15 && (
                                  <div className="footer-wrap border-top pt-2 mt-2">
                                    <PaginationPage
                                      // list={list}
                                      totalCount={totalCount}
                                      limit={limit}
                                      page_no={page_no}
                                      pageNumber={page_no}
                                      showLimit={"false"}
                                      handleChangePagination={
                                        handleChangePagination
                                      }
                                      handleChangeLimit={handleChangeLimit}
                                    />
                                  </div>
                                )}
                              </div>
                            </>
                          )
                        ) : getValue(
                            pieChartData,
                            `datasets[${0}].data.length`,
                            0
                          ) === 0 ? (
                          <div style={{ height: "375px" }}>
                            <DashboardSelfComplianceNotfound />
                          </div>
                        ) : (
                          <>
                            <div className="navtabs-pillable">
                              {getValue(
                                pieChartData,
                                `datasets[${0}].data.length`,
                                0
                              ) > 0 &&
                              dataHelper(
                                getValue(
                                  pieChartData,
                                  `datasets[${0}].data`,
                                  []
                                )
                              ) > 0 &&
                              getValue(
                                pieChartData1,
                                `datasets[${0}].data.length`,
                                0
                              ) > 0 &&
                              dataHelper(
                                getValue(
                                  pieChartData1,
                                  `datasets[${0}].data`,
                                  []
                                )
                              ) > 0 ? (
                                <Nav
                                  tabs
                                  className="justify-content-end align-items-center"
                                >
                                  <NavItem>
                                    <NavLink
                                      className={
                                        activeTab === "1" ? "active" : ""
                                      }
                                      onClick={() => toggleTab("1")}
                                    >
                                      {" "}
                                      Percentage Graph
                                    </NavLink>
                                  </NavItem>

                                  <NavItem>
                                    <NavLink
                                      className={
                                        activeTab === "2" ? "active" : ""
                                      }
                                      onClick={() => toggleTab("2")}
                                    >
                                      {" "}
                                      Number Graph
                                    </NavLink>
                                  </NavItem>
                                </Nav>
                              ) : null}

                              <TabContent activeTab={activeTab}>
                                <TabPane tabId="1" className="pb-3">
                                  {getValue(
                                    pieChartData,
                                    `datasets[${0}].data.length`,
                                    0
                                  ) > 0 &&
                                  dataHelper(
                                    getValue(
                                      pieChartData,
                                      `datasets[${0}].data`,
                                      []
                                    )
                                  ) > 0 ? (
                                    <div
                                      style={{ height: "350px" }}
                                      className="vendor-graph-holder"
                                    >
                                      <div className="self-compliance-download-button-holder">
                                        <h6 className="d-none">
                                          Percentage Graph
                                        </h6>
                                        <button
                                          onClick={() =>
                                            handleDownloadPie("percentageGraph")
                                          }
                                          className="download_chart mx-1 hover-effective-icon-btn"
                                        >
                                          <DownloadNoCircleSvgComponent
                                            size={20}
                                            color={"#5F6368"}
                                          />
                                        </button>
                                      </div>
                                      {/* <Doughnut
                                        data={pieChartData}
                                        options={{
                                          ...optionsPercentage,
                                          onClick: function (evt, element) {
                                            let ind = getValue(
                                              element,
                                              `[${0}].index`,
                                              null
                                            );
                                            if (element.length > 0) {
                                              handleClickPieChart(ind);
                                            }
                                          },
                                        }}
                                        ref={chartRef}
                                      /> */}
                                      <div
                                        id="percentageGraph"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      >
                                        <ResponsivePie
                                          data={donutData}
                                          margin={{
                                            top: 40,
                                            right: 80,
                                            bottom: 40,
                                            left: -40,
                                          }}
                                          colors={colorsChartNew}
                                          innerRadius={0.5}
                                          padAngle={0}
                                          cornerRadius={0}
                                          activeOuterRadiusOffset={10}
                                          borderWidth={1}
                                          borderColor={{
                                            from: "color",
                                            modifiers: [["darker", 0.2]],
                                          }}
                                          arcLinkLabelsDiagonalLength={16}
                                          arcLinkLabelsTextColor="#333333"
                                          arcLinkLabelsThickness={2}
                                          arcLinkLabelsColor={{ from: "color" }}
                                          arcLabelsSkipAngle={2}
                                          arcLabelsTextColor={{
                                            from: "color",
                                            modifiers: [["darker", 2]],
                                          }}
                                          arcLabel={(d) =>
                                            `${d.formattedValue}%`
                                          }
                                          arcLinkLabel={(e) => {
                                            const displayValue =
                                              formatLabelValue(e.id.toString());
                                            return (
                                              `${displayValue}` +
                                              (" (" + e.value + "%)")
                                            );
                                          }}
                                          arcLinkLabelsOffset={1}
                                          arcLinkLabelsStraightLength={30}
                                          arcLinkLabelsTextOffset={6}
                                          arcLinkLabelsSkipAngle={3}
                                          onClick={(data: any) => {
                                            const index = data.arc.index;
                                            handleClickPieChart(index);
                                          }}
                                          legends={[
                                            {
                                              anchor: "top-right",
                                              direction: "column",
                                              justify: false,
                                              itemsSpacing: 5,
                                              itemWidth: 100,
                                              itemHeight: 18,
                                              itemTextColor: "#999",
                                              itemDirection: "left-to-right",
                                              itemOpacity: 1,
                                              symbolSize: 18,
                                              symbolShape: "square",
                                              onClick: (
                                                legendDonutData: any
                                              ) => {
                                                const idx = donutData.findIndex(
                                                  (s) =>
                                                    s.id === legendDonutData.id
                                                );
                                                if (idx !== -1) {
                                                  handleClickPieChart(idx);
                                                }
                                              },
                                              effects: [
                                                {
                                                  on: "hover",
                                                  style: {
                                                    itemTextColor: "#000",
                                                  },
                                                },
                                              ],
                                              data: donutData.map(
                                                (item: any, index: any) => ({
                                                  id: item.id,
                                                  label: `${item.id} (${item.value}%)`,
                                                  color:
                                                    colorsChartNew[
                                                      index %
                                                        colorsChartNew.length
                                                    ],
                                                })
                                              ),
                                            },
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <DashboardSelfComplianceNotfound />
                                  )}
                                </TabPane>

                                <TabPane tabId="2" className="pb-3">
                                  {getValue(
                                    pieChartData1,
                                    `datasets[${0}].data.length`,
                                    0
                                  ) > 0 &&
                                  dataHelper(
                                    getValue(
                                      pieChartData1,
                                      `datasets[${0}].data`,
                                      []
                                    )
                                  ) > 0 ? (
                                    <div
                                      style={{ height: "350px" }}
                                      className="vendor-graph-holder"
                                    >
                                      <div className="d-flex justify-content-between align-items-center self-compliance-download-button-holder">
                                        <h6 className="d-none">Number Graph</h6>
                                        <button
                                          onClick={() =>
                                            handleDownloadPie("numberGraph")
                                          }
                                          className="download_chart mx-1 hover-effective-icon-btn"
                                        >
                                          <DownloadNoCircleSvgComponent
                                            size={20}
                                            color={"#5F6368"}
                                          />
                                        </button>
                                      </div>
                                      {/* <Doughnut
                                        data={pieChartData1}
                                        options={{
                                          ...options,
                                          onClick: function (evt, element) {
                                            let ind = getValue(
                                              element,
                                              `[${0}].index`,
                                              null
                                            );
                                            if (element.length > 0) {
                                              handleClickPieChart(ind);
                                            }
                                          },
                                        }}
                                        ref={chartRef1}
                                      /> */}

                                      <div
                                        id="numberGraph"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      >
                                        <ResponsivePie
                                          data={numberDonutData}
                                          margin={{
                                            top: 40,
                                            right: 80,
                                            bottom: 40,
                                            left: -40,
                                          }}
                                          colors={colorsChartNew}
                                          innerRadius={0.5}
                                          padAngle={0}
                                          cornerRadius={0}
                                          activeOuterRadiusOffset={10}
                                          borderWidth={1}
                                          borderColor={{
                                            from: "color",
                                            modifiers: [["darker", 0.2]],
                                          }}
                                          arcLinkLabelsDiagonalLength={16}
                                          arcLinkLabelsTextColor="#333333"
                                          arcLinkLabelsThickness={2}
                                          arcLinkLabelsColor={{ from: "color" }}
                                          arcLabelsSkipAngle={2}
                                          arcLabelsTextColor={{
                                            from: "color",
                                            modifiers: [["darker", 2]],
                                          }}
                                          arcLabel={(d) =>
                                            `${d.formattedValue}`
                                          }
                                          arcLinkLabel={(e) => {
                                            const displayValue =
                                              formatLabelValue(e.id.toString());
                                            return (
                                              `${displayValue}` +
                                              (" (" + e.value + ")")
                                            );
                                          }}
                                          arcLinkLabelsOffset={1}
                                          arcLinkLabelsStraightLength={30}
                                          arcLinkLabelsTextOffset={6}
                                          arcLinkLabelsSkipAngle={3}
                                          onClick={(data: any) => {
                                            const index = data.arc.index;
                                            handleClickPieChart(index);
                                          }}
                                          legends={[
                                            {
                                              anchor: "top-right",
                                              direction: "column",
                                              justify: false,
                                              itemsSpacing: 5,
                                              itemWidth: 100,
                                              itemHeight: 18,
                                              itemTextColor: "#999",
                                              itemDirection: "left-to-right",
                                              itemOpacity: 1,
                                              symbolSize: 18,
                                              symbolShape: "square",
                                              onClick: (
                                                legendDonutData: any
                                              ) => {
                                                const idx =
                                                  numberDonutData.findIndex(
                                                    (s) =>
                                                      s.id ===
                                                      legendDonutData.id
                                                  );
                                                if (idx !== -1) {
                                                  handleClickPieChart(idx);
                                                }
                                              },
                                              data: numberDonutData.map(
                                                (item: any, index: any) => ({
                                                  id: item.id,
                                                  label: `${item.id} (${item.value})`,
                                                  color:
                                                    colorsChartNew[
                                                      index %
                                                        colorsChartNew.length
                                                    ],
                                                })
                                              ),
                                              effects: [
                                                {
                                                  on: "hover",
                                                  style: {
                                                    itemTextColor: "#000",
                                                  },
                                                },
                                              ],
                                            },
                                          ]}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <DashboardSelfComplianceNotfound />
                                  )}
                                </TabPane>
                              </TabContent>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
            {getValue(params, `level`, "") ? (
              <>
                {groupChartLoading ? (
                  <Loader />
                ) : getValue(groupChart, `length`, 0) > 0 &&
                  getValue(params, `level`, "") ? (
                  <>
                    <h3
                      // style={{ marginLeft: "2%" }}
                      className="self-compliance-table-title"
                    >
                      {getValue(selectedEntity, `[${0}].group_name`, "")}
                    </h3>
                    {/* <SelfComplianceTable
                      headerList={headerList}
                      data={groupChart}
                      handleNavigate={handleNavigate}
                    /> */}

                    {getValue(params, `group_name`, "") === "Function" ? (
                      <ExpandableComplianceTable
                        parentData={groupChart}
                        handleNavigate={handleNavigate}
                        fromDate={from_date}
                        toDate={to_date}
                        level={getValue(params, `level`, "")}
                      />
                    ) : (
                      <SelfComplianceTable
                        headerList={headerList}
                        data={groupChart}
                        handleNavigate={handleNavigate}
                      />
                    )}
                  </>
                ) : // <Notfound />
                null}
              </>
            ) : null}

            {/* In your parent component */}
            {/* {getValue(params, `level`, "") ? (
              <>
                {groupChartLoading ? (
                  <Loader />
                ) : getValue(groupChart, `length`, 0) > 0 &&
                  getValue(params, `level`, "") ? (
                  <>
                    <h3 className="self-compliance-table-title">
                      {getValue(selectedEntity, `[${0}].group_name`, "")}
                    </h3>
                    <ExpandableComplianceTable
                      parentData={groupChart}
                      handleNavigate={handleNavigate}
                      fromDate={from_date}
                      toDate={to_date}
                      // limit={limit}
                      level={getValue(params, `level`, "")}
                    />
                  </>
                ) : null}
              </>
            ) : null} */}
          </div>
          {getValue(params, `level`, "") ? (
            <div className="footer-wrap">
              <FooterWrapper
                list={headerList}
                totalCount={totalCountTable}
                limit={limitTable}
                page_no={page_no_table}
                handleChangePagination={handleChangePaginationTable}
                handleChangeLimit={handleChangeLimitTable}
                hideRowsPerPage={true}
              />
            </div>
          ) : null}
        </>
      )}
      {/* <div className="text-right">
        <img src="/images/profile-illustration.svg" className="img-fluid" />
      </div> */}
    </DashboardLayout>
  );
}

{
  /* <Bar
  options={{
    ...options,
    onClick: function (evt, element) {
      let ind = getValue(element, `[${0}].index`, null);
      if (element.length > 0) {
        handleClickPieChart(ind);
      }
    },
  }}
  data={barChartData}
/> */
}
